var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 40,
    viewBox: "0 0 138 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0659 39.1358H0.161865V0.275757H21.6799C30.9019 0.275757 36.7019 5.55375 36.7019 14.7758C36.7019 23.9978 30.9019 29.3338 21.6799 29.3338H11.0659V39.1358ZM20.4619 10.0778H11.0659V19.5318H20.4619C24.2899 19.5318 25.8559 18.7778 25.8559 14.7758C25.8559 10.8318 24.2899 10.0778 20.4619 10.0778Z",
    fill: "#3461FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5273 39.1358H36.2893L53.0513 0.275757H68.6533L85.4733 39.1358H72.9453L69.9873 31.9438H51.5433L48.5273 39.1358ZM57.9233 16.6898L55.6613 22.1418H65.9853L63.7233 16.6898L61.1713 10.1358H60.4173L57.9233 16.6898Z",
    fill: "#3461FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1366 39.1358H86.2326V0.275757H101.023L108.157 16.3998L111.985 26.4338H112.739L116.393 16.3998L123.179 0.275757H137.969V39.1358H127.065V23.0698L127.471 16.5738H126.717L124.513 23.0698L118.713 36.8158H105.489L99.6886 23.0698L97.4846 16.5738H96.7306L97.1366 23.0698V39.1358Z",
    fill: "#3461FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo-1.c34712d8f181097e74c056cfc3955172.svg";
export { ForwardRef as ReactComponent };